var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "CustomTab",
        {
          attrs: {
            "content-class": "mt-3",
            "nav-class": "nav-vue-underline",
            "no-nav-style": true
          }
        },
        [
          _c(
            "CustomTabItem",
            { staticClass: "mt-2", attrs: { title: "Información General" } },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12 text-bold bold mb-3" }, [
                  _c("i", { staticClass: "fa fa-info-circle color-orange" }),
                  _vm._v(" Información Adicional del Estudiante ")
                ]),
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Número de Registro:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(_vm._s(_vm.item.studentRegisterNumber))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Número de Seguro Social:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "font-16 font-weight-normal color-black d-flex align-items-center"
                        },
                        [
                          _c("div", { staticClass: "ssn-size" }, [
                            _vm._v(_vm._s(_vm.ssn(_vm.item.studentSSN)))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-items-center",
                              on: {
                                click: function($event) {
                                  _vm.showSSN = !_vm.showSSN
                                }
                              }
                            },
                            [
                              _c("em", {
                                staticClass: "cursor-pointer font-16",
                                class: {
                                  "far fa-eye": !_vm.showSSN,
                                  "far fa-eye-slash": _vm.showSSN
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Estatus de Estudiante:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(_vm._s(_vm.item.studentStatus.name))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Impedimento:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(_vm._s(_vm.item.studentImpediment.name))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Región:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(_vm._s(_vm.item.region.name))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Distrito:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(_vm._s(_vm.item.district.name))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-6 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Escuela:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(_vm._s(_vm.item.school.name))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Nombre Contacto:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(_vm._s(_vm.item.contact.name || "-"))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Parentesco Contacto:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.item.contact.value.contactRelation || "-"
                            ) +
                            " "
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Correo Electrónico Contacto:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.item.contact.value.contactEmail || "-") +
                            " "
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Teléfono Contacto:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.item.contact.value.contactTelephone || "-"
                            ) +
                            " "
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Dirección Postal:")
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.item.studentPostalAddress || "-") +
                            " "
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm.item.bankRequestDate
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-bold bold mb-3 mt-3" },
                      [
                        _c("i", {
                          staticClass: "fa fa-info-circle color-orange"
                        }),
                        _vm._v(" Información Solicitud al Banco ")
                      ]
                    ),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Fecha de Solicitud al Banco:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(
                              _vm._s(_vm._f("date")(_vm.item.bankRequestDate))
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.item.receptionDate
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-bold bold mb-3 mt-3" },
                      [
                        _c("i", {
                          staticClass: "fa fa-info-circle color-orange"
                        }),
                        _vm._v(" Información Recibida en SAEE ")
                      ]
                    ),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Fecha de Recibida en SAEE:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(
                              _vm._s(_vm._f("date")(_vm.item.receptionDate))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("¿Qué se recibió?:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.receptionType))
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v(
                              " Fecha de Recibo " +
                                _vm._s(
                                  _vm.item.receptionType ==
                                    _vm.ByReceptionType.PIN
                                    ? "de Tarjeta"
                                    : _vm.item.receptionType ==
                                      _vm.ByReceptionType.Tarjeta
                                    ? "de PIN"
                                    : ""
                                ) +
                                ": "
                            )
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("date")(
                                    _vm.item.additionalReceptionDate
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Comentario:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.receptionComment || "-"))
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.item.cseeDeliveryDate
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-bold bold mb-3 mt-3" },
                      [
                        _c("i", {
                          staticClass: "fa fa-info-circle color-orange"
                        }),
                        _vm._v(" Información Entregada al CSEE ")
                      ]
                    ),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Fecha de Entregada al CSEE:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(
                              _vm._s(_vm._f("date")(_vm.item.cseeDeliveryDate))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("CSEE:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.cseeDeliveryType.name))
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Recibido por:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.cseeReceivedByName))
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.item.deliveryDate
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-bold bold mb-3 mt-3" },
                      [
                        _c("i", {
                          staticClass: "fa fa-info-circle color-orange"
                        }),
                        _vm._v(" Información Entregada ")
                      ]
                    ),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Fecha:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(
                              _vm._s(_vm._f("date")(_vm.item.deliveryDate))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Método de Entrega:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.deliveryMethod.name))
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Comentario:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.deliveryComment || "-"))
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.item.status.id === _vm.CardManagementStatus.Archivada
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-bold bold mb-3 mt-3" },
                      [
                        _c("i", {
                          staticClass: "fa fa-info-circle color-orange"
                        }),
                        _vm._v(" Información Archivada ")
                      ]
                    ),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Comentario:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.archiveComment || "-"))
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.item.cancellationDate
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-bold bold mb-3 mt-3" },
                      [
                        _c("i", {
                          staticClass: "fa fa-info-circle color-orange"
                        }),
                        _vm._v(" Informacion de Cancelación ")
                      ]
                    ),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Fecha:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(
                              _vm._s(_vm._f("date")(_vm.item.cancellationDate))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Número de Tarjeta:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.cancellationCardNumber))
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Razón:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.item.cancellationBalance >= 0
                                    ? _vm.item.cancellationReason
                                    : "Reclamación"
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Balance:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(" " + _vm._s(_vm.cancellationBalance) + " ")
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-12 mt-3" }, [
                          _c("div", { staticClass: "data-label" }, [
                            _vm._v("Comentario:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.item.cancellationComment || "-"))
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.item.claims.length
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-bold bold mb-3 mt-3" },
                      [
                        _c("i", {
                          staticClass: "fa fa-info-circle color-orange"
                        }),
                        _vm._v(" Información de Reclamaciones ")
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(_vm.item.claims, function(claim) {
                        return _c(
                          "callout",
                          {
                            key: claim.id,
                            attrs: {
                              "class-main": "mb-3",
                              "has-border": false,
                              "has-toggle": false
                            }
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "data-label" }, [
                                  _vm._v("Fecha:")
                                ]),
                                _c("span", { staticClass: "data" }, [
                                  _vm._v(_vm._s(_vm._f("date")(claim.date)))
                                ])
                              ]),
                              _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "data-label" }, [
                                  _vm._v("Tipo:")
                                ]),
                                _c("span", { staticClass: "data" }, [
                                  _vm._v(_vm._s(claim.type.name || "-"))
                                ])
                              ]),
                              _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "data-label" }, [
                                  _vm._v("Razón:")
                                ]),
                                _c("span", { staticClass: "data" }, [
                                  _vm._v(_vm._s(claim.reason.name || "-"))
                                ])
                              ]),
                              _c("div", { staticClass: "col-md-3" }, [
                                _c("div", { staticClass: "data-label" }, [
                                  _vm._v("Comentario:")
                                ]),
                                _c("span", { staticClass: "data" }, [
                                  _vm._v(_vm._s(claim.comment || "-"))
                                ])
                              ])
                            ])
                          ]
                        )
                      }),
                      1
                    )
                  ])
                : _vm._e()
            ]
          ),
          _c(
            "CustomTabItem",
            { staticClass: "mt-2", attrs: { title: "Historial" } },
            [
              _c(
                "div",
                [
                  _c("div", { staticClass: "col-md-12 text-bold bold mb-3" }, [
                    _c("i", { staticClass: "fa fa-info-circle color-orange" }),
                    _vm._v(" Historial de Estatus ")
                  ]),
                  _c("History", { attrs: { card: _vm.item } })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }